<template>
	<div :class="['article-list-item', 'col-md-01', 'tile-webinar', webinarTypeClass]">
    <h3>{{ result.WebinarTitle }}</h3>
    <div>
        <p><b>{{ webinarType }} Webinar</b><span v-if="webinarDate">{{ webinarDate }}</span></p>
        <p v-html="result.WebinarDescription"></p>
        <a v-bind:href="result.WebinarURL" v-if="result.WebinarURL" class="btn btn-primary">VIEW</a>
    </div>

</div>

</template>


<script>
	import DateFormatService from '../../common/date-format.service';
	
    export default {
	props: {
			result: {
				type: Object,
				default: () => {}
			},
		},

	data: function() {
		return  {

		}
	},
	methods: {
				formatDate: function(date) {
					return DateFormatService.formatDate(date);
			}
		},
	computed: {
			webinarTypeClass: function () {
				return this.result.WebinarType ? "on-demand js-webinar-on-demand" : "live js-webinar-live"
		},
			webinarType: function () {
				return this.result.WebinarType ? "On Demand" : "Live"
		},
			webinarDate: function () {
				const webinarDate = new Date(this.result.WebinarDate);

				// the WebinarDate from the controller is MinValue, so Jan 1, 0001 - which translates to Jan 1, 1970 (and potentially UTC translation)
				// Anything equal to or less than 1970 is the equivalent of a null date for Webinars in the database
				const isMinValue = webinarDate.getFullYear() <= 1970

                return !isMinValue ?
                    " - " + Intl.DateTimeFormat('en-US', { year: 'numeric', month: 'long', day: '2-digit' }).format(new Date(this.result.WebinarDate)) :
					"";
		},

	}
}
</script>